import * as React from 'react';

interface Props {
	answer: string;
	questions: { [name: string]: string; }[];
	declinedQuestionNames: string[];
}

const ActivitiesQuestionAnswer: React.StatelessComponent<Props> = (props) => {

	const activitiesAnswer = JSON.parse(props.answer);

	const keyOfNone = 'activitiesNoneOfTheAbove';
	const noneActivity = activitiesAnswer[keyOfNone] === true;

	const aviation = 'aviation';
	const aviationLicense = 'aviationLicense';
	const aviationInstrumentRating = 'aviationInstrumentRating';
	const aviationHoursExperience = 'aviationHoursExperience';
	const aviationHoursAnnually = 'aviationHoursAnnually';
	const aviationAccidents = 'aviationAccidents';
	const hangGliding = 'hangGliding';
	const hangGlidingStunt = 'hangGlidingStunt';
	const ultralightFlying = 'ultralightFlying';
	const ultralightFlyingStunts = 'ultralightFlyingStunts';
	const scubaDiving = 'scubaDiving';
	const backcountrySkiing = 'backcountrySkiing';
	const heliSkiSnowboarding = 'heliSkiSnowboarding';
	const outOfBoundsSkiingSnowboarding = 'outOfBoundsSkiingSnowboarding';
	const backCountrySnowMobiling = 'backCountrySnowMobiling';
	const mountainClimbing = 'mountainClimbing';
	const mountainClimbingTall = 'mountainClimbingTall';
	const skydivingActivities = 'skydivingActivities';
	const skydiving = 'skydiving';
	const skydivingOneTime = 'skydivingOneTime';
	const wingsuitFlying = 'wingsuitFlying';
	const parachuting = 'parachuting';
	const parachutingOneTime = 'parachutingOneTime';
	const skysurfing = 'skysurfing';
	const canopyPiloting = 'canopyPiloting';
	const skydivingExtreme = 'skydivingExtreme';
	const motorizedRacing = 'motorizedRacing';
	const bungeeJumping = 'bungeeJumping';
	const bungeeJumpingOneTime = 'bungeeJumpingOneTime';
	const fightSports = 'fightSports';

	const causeDecline = (questionName: string) => {
		return props.declinedQuestionNames.some(d => d === questionName);
	};
	// tslint:disable
	return noneActivity ? (
		<div>
			None
		</div>
	) : (
		<div className="mt-2">
			<dl>
			{activitiesAnswer[aviation] &&
			<div>
				<div className="font-weight-bold">Private recreational or non-scheduled commercial aircraft aviation</div>
				<div className={`border border-success`}>
					<div className={causeDecline(aviationLicense) ? `p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap` : `border-bottom p-3`}>
						<dt>What type of license do you hold?</dt>
						<div>{activitiesAnswer[aviationLicense]}</div>
					</div>
					<div
						className={causeDecline(aviationInstrumentRating) ? 
							`p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap` : `border-bottom p-3`}
					>
						<dt>Do you have a valid Instrument Rating?</dt>
						<div>{activitiesAnswer[aviationInstrumentRating] ? 'Yes' : 'No'}</div>
					</div>
					<div
						className={causeDecline(aviationHoursExperience) ? 
							`p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap` : `border-bottom p-3`}
					>
						<dt>How many pilot-in-command hours of experience do you have?</dt>
						<div>{activitiesAnswer[aviationHoursExperience]}</div>
					</div>
					<div
						className={causeDecline(aviationHoursAnnually) ?
							`p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap` : `border-bottom p-3`}
					>
						<dt>How many hours do you typically fly annually?</dt>
						<div>{activitiesAnswer[aviationHoursAnnually]}</div>
					</div>
					<div className={causeDecline(aviationAccidents) ? `p-3 border border-danger border-overlap` : `border-bottom p-3`}>
						<dt>Have you had any aviation accidents?</dt>
						<div>{activitiesAnswer[aviationAccidents]  ? 'Yes' : 'No'}</div>
					</div>
				</div>
			</div>}
			{activitiesAnswer[hangGliding] && 
			<div className="mt-3">
				<div className="font-weight-bold">Hang-gliding</div>
				<div className={causeDecline(hangGlidingStunt) ? `p-3 border border-danger` : `p-3 border border-success`}>
					<dt>Have you been or will you be stunt-flying or making record-setting attempts?</dt>
					<div>{activitiesAnswer[hangGlidingStunt]  ? 'Yes' : 'No'}</div>
				</div>
			</div>}
			{activitiesAnswer[ultralightFlying] &&
			<div className="mt-3">
				<div className="font-weight-bold">Ultra-light flying</div>
				<div
					className={causeDecline(ultralightFlyingStunts) ?
					`p-3 border border-danger` : `p-3 border border-success`}
				>
					<dt>Have you been or will you be piloting non-licensed aircraft,
							performing aerobatics or stunts, or making record-setting attempts?</dt>
					<div>{activitiesAnswer[ultralightFlyingStunts]  ? 'Yes' : 'No'}</div>
				</div>
			</div>}
			{activitiesAnswer[scubaDiving] && 
			<div className="mt-3">
				<div className="font-weight-bold">Scuba diving beyond 100 feet or specialized diving</div>
				<div className={causeDecline(scubaDiving) ? `p-3 border border-danger` : `border p-3`}>
					<div>{activitiesAnswer[scubaDiving]  ? 'Yes' : 'No'}</div>
				</div>
			</div>}
			{activitiesAnswer[backcountrySkiing] &&
			<div className="mt-3">
				<div className="font-weight-bold">
					Heli-skiing or snowboarding, out-of-bounds or backcountry skiing or snowboarding, or backcountry snowmobiling
				</div>
				<div className={`border border-success p-3`}>
					<div className={`font-weight-bold`}>Which activities, specifically?</div>
					<div className="border">
						<div className={causeDecline(heliSkiSnowboarding) ? `p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap` : `border-bottom p-3`}>
							<dt>Heli-skiing or snowboarding</dt>
							<div>{activitiesAnswer[heliSkiSnowboarding]  ? 'Yes' : 'No'}</div>
						</div>
						<div
							className={causeDecline(outOfBoundsSkiingSnowboarding) ? 
								`p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap` : `border-bottom p-3`}
						>
							<dt>Out-of-bounds or backcountry skiing or snowboarding</dt>
							<div>{activitiesAnswer[outOfBoundsSkiingSnowboarding]  ? 'Yes' : 'No'}</div>
						</div>
						<div
							className={causeDecline(backCountrySnowMobiling) ? 
								`p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap` : `border-bottom p-3`}
						>
							<dt>Backcountry snowmobiling</dt>
							<div>{activitiesAnswer[backCountrySnowMobiling]  ? 'Yes' : 'No'}</div>
						</div>
					</div>
				</div>
			</div>}
			{activitiesAnswer[mountainClimbing] &&
			<div className="mt-3">
				<div className="font-weight-bold">Outdoor mountain climbing using technical equipment</div>
				<div
					className={causeDecline(mountainClimbingTall) ?
					`p-3 border border-danger` : `p-3 border border-success`}
				>
					<dt>Have you been or will you be climbing in the Himalayas or at an altitude above 6,000m or 19,700ft?</dt>
					<div>{activitiesAnswer[mountainClimbingTall]  ? 'Yes' : 'No'}</div>
				</div>
			</div>
			}
			{activitiesAnswer[skydivingActivities] &&
			<div className="mt-3">
				<div className="font-weight-bold">Skydiving, wingsuit flying, parachuting, skysurfing, or canopy piloting</div>
				<div className={`border border-success p-3 pb-0`}>
					<dt>Which activities, specifically?</dt>
					<div className="border">
						<div className={causeDecline(skydiving) ? `p-3 border border-danger border-top-overlap border-right-overlap border-left-overlap` : `border-bottom p-3`}>
							<dt>Skydiving</dt>
							<div>{activitiesAnswer[skydiving]  ? 'Yes' : 'No'}</div>
							<div className={causeDecline(skydivingOneTime) ? `mt-2 p-3 border border-danger border-top-overlap` : `border p-3 mt-2`}>
								<dt>Was this a one-time occurrence in the past, with no intention of doing it again?</dt>
								<div>{activitiesAnswer[skydivingOneTime]  ? 'Yes' : 'No'}</div>
							</div>
						</div>
						<div className={causeDecline(wingsuitFlying) ? `p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap` : `border-bottom p-3`}>
							<dt>Wingsuit flying</dt>
							<div>{activitiesAnswer[wingsuitFlying]  ? 'Yes' : 'No'}</div>
						</div>
						<div className={causeDecline(parachuting) ? `p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap` : `border-bottom p-3`}>
							<dt>Parachuting</dt>
							<div>{activitiesAnswer[parachuting]  ? 'Yes' : 'No'}</div>
							<div className={causeDecline(parachutingOneTime) ? `mt-2 border p-3 border-danger` : `border p-3 mt-2`}>
								<dt>Was this a one-time occurrence in the past, with no intention of doing it again?</dt>
								<div>{activitiesAnswer[parachutingOneTime]  ? 'Yes' : 'No'}</div>
							</div>
						</div>
						<div className={causeDecline(skysurfing) ? `p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap` : `border-bottom p-3`}>
							<dt>Skysurfing</dt>
							<div>{activitiesAnswer[skysurfing]  ? 'Yes' : 'No'}</div>
						</div>
						<div className={causeDecline(canopyPiloting) ? `p-3 border border-danger border-top-overlap border-left-overlap border-right-overlap` : `border-bottom p-3`}>
							<dt>Canopy piloting</dt>
							<div>{activitiesAnswer[canopyPiloting]  ? 'Yes' : 'No'}</div>
						</div>
						<div className={causeDecline(skydivingExtreme) ? `p-3 border border-danger border-overlap` : `border-bottom p-3`}>
							<dt>Have you been or will you be making record-setting attempts?</dt>
							<div>{activitiesAnswer[skydivingExtreme]  ? 'Yes' : 'No'}</div>
						</div>
					</div>
				</div>
			</div>}
			{activitiesAnswer[motorizedRacing] &&
			<div className="mt-3">
				<div className="font-weight-bold">Motorized racing (e.g., car, motorcycle, motorboat, or snowmobile)</div>
				<div className="p-3 border">
					{activitiesAnswer[motorizedRacing]  ? 'Yes' : 'No'}
				</div>
			</div>}
			{activitiesAnswer[bungeeJumping] &&
			<div className="mt-3">
				<div className="font-weight-bold">Bungee jumping</div>
				<div
					className={causeDecline(bungeeJumpingOneTime) ?
					`p-3 border border-danger` : `p-3 border border-success`}
				>
						<dt>Was this a one-time occurrence in the past, with no intention of doing it again?</dt>
						<div>{activitiesAnswer[bungeeJumpingOneTime]  ? 'Yes' : 'No'}</div>
				</div>
			</div>
			}
			{activitiesAnswer[fightSports] && 
			<div className="mt-3">
				<div className="font-weight-bold">
					Competitive fight sports (e.g., mixed martial arts, boxing, muay thai, etc.) above the amateur level
				</div>
				<div className={causeDecline(fightSports) ? `p-3 border border-danger` : `border p-3`}>
					<div>{activitiesAnswer[fightSports]  ? 'Yes' : 'No'}</div>
				</div>
			</div>}
			</dl>
		</div>
	);
};

export default ActivitiesQuestionAnswer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/QASubComponents/ActivitiesQuestionAnswer.tsx